import styled from 'styled-components'

export default styled.main`
	padding: 20px;
`



// WEBPACK FOOTER //
// ./src/primitives/Main.js